/** Metadatos de los 23 iconos oficiales — generados desde iconografia/ */
export const OFFICIAL_ICONS = [
    // PREVENCION
    { id: 'hidratacion', label: 'Hidratación', category: 'prevencion', source: 'official', asset: 'IconHidratacion', folder: 'PREVENCION' },
    { id: 'descansos', label: 'Descansos', category: 'prevencion', source: 'official', asset: 'IconDescansos', folder: 'PREVENCION' },
    { id: 'ropa-adecuada', label: 'Ropa adecuada', category: 'prevencion', source: 'official', asset: 'IconRopaAdecuada', folder: 'PREVENCION' },
    { id: 'horarios', label: 'Horarios', category: 'prevencion', source: 'official', asset: 'IconHorarios', folder: 'PREVENCION', tags: ['agenda'] },
    { id: 'proteccion-solar', label: 'Protección solar', category: 'prevencion', source: 'official', asset: 'IconProteccionSolar', folder: 'PREVENCION' },
    { id: 'alimentacion', label: 'Alimentación', category: 'prevencion', source: 'official', asset: 'IconAlimentacion', folder: 'PREVENCION' },
    // INTELIGENCIA
    { id: 'laboratorio-clinico', label: 'Laboratorio clínico', category: 'servicios', source: 'official', asset: 'IconLaboratorioClinico', folder: 'INTELIGENCIA', tags: ['labsyso'] },
    { id: 'mediciones-higienicas', label: 'Mediciones higiénicas ocupacionales', category: 'servicios', source: 'official', asset: 'IconMedicionesHigienicas', folder: 'INTELIGENCIA', tags: ['vigilancia', 'labsyso'] },
    { id: 'gestion-riesgo', label: 'Gestión de riesgo', category: 'servicios', source: 'official', asset: 'IconGestionRiesgo', folder: 'INTELIGENCIA', tags: ['puestos', 'riesgos'] },
    // GABINETE
    { id: 'visiometria', label: 'Visiometría', category: 'gabinete', source: 'official', asset: 'IconVisiometria', folder: 'GABINETE' },
    { id: 'electrocardiograma', label: 'Electrocardiograma', category: 'gabinete', source: 'official', asset: 'IconElectrocardiograma', folder: 'GABINETE' },
    { id: 'rayos-x', label: 'Rayos X', category: 'gabinete', source: 'official', asset: 'IconRayosX', folder: 'GABINETE' },
    { id: 'espirometria', label: 'Espirometría', category: 'gabinete', source: 'official', asset: 'IconEspirometria', folder: 'GABINETE' },
    { id: 'audiometria', label: 'Audiometría', category: 'gabinete', source: 'official', asset: 'IconAudiometria', folder: 'GABINETE' },
    { id: 'ultrasonografia', label: 'Ultrasonografía', category: 'gabinete', source: 'official', asset: 'IconUltrasonografia', folder: 'GABINETE' },
    // OCUPACIONAL
    { id: 'preocupacionales', label: 'Preocupacionales', category: 'examenes', source: 'official', asset: 'IconPreocupacionales', folder: 'OCUPACIONAL' },
    { id: 'ocupacionales', label: 'Ocupacionales', category: 'examenes', source: 'official', asset: 'IconOcupacionales', folder: 'OCUPACIONAL' },
    { id: 'postocupacionales', label: 'Postocupacionales', category: 'examenes', source: 'official', asset: 'IconPostocupacionales', folder: 'OCUPACIONAL' },
    // MONITOREO
    { id: 'evaluacion-medica', label: 'Evaluación médica ocupacional', category: 'proceso', source: 'official', asset: 'IconEvaluacionMedica', folder: 'MONITOREO', tags: ['expediente'] },
    { id: 'toma-muestras', label: 'Toma de muestras en sitio', category: 'proceso', source: 'official', asset: 'IconTomaMuestras', folder: 'MONITOREO', tags: ['labsyso'] },
    { id: 'analisisinterpretacion', label: 'Análisis e interpretación de resultados', category: 'proceso', source: 'official', asset: 'IconAnalisisinterpretacion', folder: 'MONITOREO', tags: ['labsyso'] },
    { id: 'examenes-complementarios', label: 'Exámenes complementarios', category: 'proceso', source: 'official', asset: 'IconExamenesComplementarios', folder: 'MONITOREO', tags: ['gabinete', 'labsyso'] },
    { id: 'capacitacion-prevencion', label: 'Capacitación y prevención', category: 'proceso', source: 'official', asset: 'IconCapacitacionPrevencion', folder: 'MONITOREO', tags: ['academia'] },
];
/** Iconos de plataforma — no están en el catálogo oficial AGDYSA (pendientes de diseño) */
export const EXTENDED_ICONS = [
    {
        id: 'diagnostico',
        label: 'Diagnóstico',
        category: 'extended',
        source: 'placeholder',
        asset: 'IconDiagnostico',
        pending: true,
        tags: ['labsyso', 'investigacion'],
    },
    {
        id: 'grupo-trabajadores',
        label: 'Grupo de trabajadores',
        category: 'extended',
        source: 'placeholder',
        asset: 'IconGrupoTrabajadores',
        pending: true,
        tags: ['trabajadores', 'empresas'],
    },
];
/** Alias — compatibilidad y equivalencias aprobadas */
export const ALIAS_ICONS = [
    {
        id: 'examen-ocupacional',
        label: 'Examen ocupacional',
        category: 'proceso',
        source: 'alias',
        asset: 'IconOcupacionales',
        aliasOf: 'ocupacionales',
        tags: ['labsyso'],
    },
    {
        id: 'analisis-interpretacion',
        label: 'Análisis e interpretación de resultados',
        category: 'proceso',
        source: 'alias',
        asset: 'IconAnalisisinterpretacion',
        aliasOf: 'analisisinterpretacion',
    },
];
export const ICON_CATALOG = [
    ...OFFICIAL_ICONS,
    ...EXTENDED_ICONS,
    ...ALIAS_ICONS,
];
export const ICON_CATEGORIES = {
    prevencion: 'Prevención y protocolos',
    servicios: 'Servicios AGDYSA',
    gabinete: 'Gabinete ocupacional',
    examenes: 'Tipos de examen médico',
    proceso: 'Proceso de atención',
    extended: 'Plataforma (pendientes AGDYSA)',
};
/** Resuelve alias → id canónico */
export function resolveIconId(id) {
    const entry = ICON_CATALOG.find((i) => i.id === id);
    if (entry?.aliasOf)
        return entry.aliasOf;
    return id;
}
export function getIconById(id) {
    const resolved = resolveIconId(id);
    return ICON_CATALOG.find((i) => i.id === resolved || i.id === id);
}
export function getIconsByCategory(category) {
    return ICON_CATALOG.filter((i) => i.category === category && i.source !== 'alias');
}
export function getOfficialIcons() {
    return OFFICIAL_ICONS;
}
export function getPendingIcons() {
    return EXTENDED_ICONS.filter((i) => i.pending);
}
